var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplitPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.269531,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FFC1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 40.421V24.118C18.6666 21.8485 18.6666 20.7137 19.3899 20.3415C20.1131 19.9693 21.0365 20.6289 22.8833 21.948L24.9916 23.454C25.8127 24.0405 26.2233 24.3338 26.445 24.7645C26.6666 25.1953 26.6666 25.6998 26.6666 26.7089V37.8301C26.6666 38.8392 26.6666 39.3437 26.445 39.7745C26.2233 40.2052 25.8127 40.4985 24.9916 41.085L22.8833 42.5909C21.0365 43.9101 20.1131 44.5696 19.3899 44.1975C18.6666 43.8253 18.6666 42.6905 18.6666 40.421Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 40.421V24.118C45.3334 21.8485 45.3334 20.7137 44.6101 20.3415C43.8869 19.9693 42.9635 20.6289 41.1167 21.948L39.0084 23.454C38.1873 24.0405 37.7767 24.3338 37.555 24.7645C37.3334 25.1953 37.3334 25.6998 37.3334 26.7089V37.8301C37.3334 38.8392 37.3334 39.3437 37.555 39.7745C37.7767 40.2052 38.1873 40.4985 39.0084 41.085L41.1167 42.5909C42.9635 43.9101 43.8869 44.5696 44.6101 44.1975C45.3334 43.8253 45.3334 42.6905 45.3334 40.421Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.9362V29.6029",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.2695V18.9362",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.6029V40.2695",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplitPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/splitPdf.4146bea8af0ac5d657a3a254065600c8.svg";